import $ from 'jquery';
import 'slick-carousel';

var $slider = $('.js-slider');

$slider.on('init', function () {
    $('.slider__load-image').hide();
});

$slider.slick({
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    arrows: true,
    dots: true,
    draggable: false,
    prevArrow: '<i class="slick-prev fal fa-chevron-left"></i>',
    nextArrow: '<i class="slick-next fal fa-chevron-right"></i>',
    appendArrows: $('<div>').addClass('absolute-container arrow-container').insertAfter('.js-slider'),
    responsive: [{
        breakpoint: 992,
        settings: {
            draggable: true
        }
    }]
});

var $interfererSlider = $('.interferer-slider__slides');

$interfererSlider.each(function () {
    var $this = $(this);
    $(this).slick({
        infinite: true,
        arrows: true,
        dots: false,
        draggable: false,
        fade: true,
        prevArrow: '<div class="slick-prev interferer-slider__arrow"></div>',
        nextArrow: '<div class="slick-next interferer-slider__arrow"></div>',
        appendArrows: $('<div>').addClass('interferer-slider__arrows').insertAfter(this),
        responsive: [{
            breakpoint: 992,
            settings: {
                arrows: false
            }
        }]
    });

    $(this).find('.interferer-slider__arrow--prev').on('click', function () {
        $this.slick('slickPrev')
    })
    $(this).find('.interferer-slider__arrow--next').on('click', function () {
        $this.slick('slickNext')
    })
})

var $newsSlider = $('.news-slider__slides');

$newsSlider.each(function () {
    $(this).slick({
        infinite: true,
        arrows: true,
        dots: false,
        slidesToShow: 3,
        draggable: false,
        prevArrow: '<div class="slick-prev news-slider__arrow"></div>',
        nextArrow: '<div class="slick-next news-slider__arrow"></div>',
        appendArrows: $('<div>').addClass('news-slider__arrows').insertBefore(this),
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
})


var $eventSlider = $('.event-slider__slides');

$eventSlider.each(function () {
    $(this).slick({
        infinite: true,
        arrows: true,
        slidesToShow: 3,
        dots: false,
        draggable: false,
        prevArrow: '<div class="slick-prev event-slider__arrow"></div>',
        nextArrow: '<div class="slick-next event-slider__arrow"></div>',
        appendArrows: $('<div>').addClass('event-slider__arrows').insertBefore(this),
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
})


var $jobteaserSlider = $('.jobteaser__items');

$jobteaserSlider.each(function () {
    $(this).slick({
        slidesToShow: 3,
        infinite: true,
        arrows: true,
        dots: false,
        draggable: false,
        prevArrow: '<div class="slick-prev jobteaser__arrow"></div>',
        nextArrow: '<div class="slick-next jobteaser__arrow"></div>',
        appendArrows: $('<div>').addClass('jobteaser__arrows').insertBefore(this),
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }]
    });
})